<form edlFocusTrap [formGroup]="form" (ngSubmit)="submit(form)" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Confirm: Remove User</h4>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12">
                <label class="form-label">
                    <div>Send Email Notifications <span class="required">*</span></div>
                    <toggle-indicator formControlName="ShouldSendNotifications" OnLabel="Yes" OffLabel="No"></toggle-indicator>
                </label>
            </div>
        </div>
        <p>User will be removed from this item and item will be removed from the user's My Compliance Items page. The user will also receive an email notification indicating that they are no longer responsible for completing this item. Once removed, the user’s current status will be saved in case user is added back to this item in the future.</p>
        <br/>
        <div class='alert alert-info' role='alert' *ngIf="portalHelpersService.isAct48Enabled(portalSettings)">
            <b>Important Note Regarding Act 48 Items</b> - If this item has already been approved for this user and the user has earned Act 48 hours or Para hours, those hours will remain. If you want to remove the hours from the system and/or PERMS, first Reopen this item (hours will be retracted) and then remove this user.
        </div>
    </div>
    <div class="modal-footer">
        <button [ladda]="busy" type="submit" class="btn btn-primary ok-button" [disabled]="form.invalid ">Ok</button>
        <button [ladda]="busy" type="button" class="btn btn-info cancel-button" (click)="cancel()">Cancel</button>
    </div>
</form>


